import _merge from 'lodash/merge';
import { getQueryString } from 'ljit-lib/qs-utils';
import { downloadBlob } from '../file-utils';

const NAME = 'api-fetcher';

export const isConfigRequired = (configName = '') => {
	throw new Error(`[${NAME}]: ${configName} is required`);
};

export const merge = (...args) => _merge(...args);

/* eslint-disable */
export const isAbsoluteUrl = url => /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
/* eslint-enable */

export const combineUrls = (baseUrl = '', relativeUrl = '') => {
	return baseUrl.replace(/\/+$/, '') + '/' + relativeUrl.replace(/^\/+/, '');
};

export const buildFullPath = (baseUrl = '', relativeUrl = '') => {
	if (baseUrl && !isAbsoluteUrl(relativeUrl)) {
		return combineUrls(baseUrl, relativeUrl);
	}

	return relativeUrl;
};

export const buildUrl = (url, queries) => {
	let _url = url;

	if (!queries) {
		return _url;
	}

	const queryStrings = getQueryString(queries);

	if (queryStrings) {
		const connectTag = _url.indexOf('?') < 0 ? '?' : '&';

		_url += connectTag + queryStrings;
	}

	return _url;
};

export const downloadFileByBlobRes = (res, fileName) => {
	try {
		const blob = res.response;
		const contentDisposition = res.xhr.getResponseHeader('Content-Disposition');
		let _fileName = fileName;

		if (!fileName && contentDisposition) {
			const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
			const matches = filenameRegex.exec(contentDisposition);

			if (matches !== null && matches[1]) {
				_fileName = matches[1].replace(/['"]/g, '');
			}

			if (!_fileName) {
				_fileName = 'unknown';
			}
		}

		downloadBlob(blob, _fileName);

		return true;
	} catch (error) {
		console.error('downloadFileByBlobRes:', error);
		return false;
	}
};
